/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailywhen2Inputs */

const en_dropdailywhen2 = /** @type {(inputs: Dropdailywhen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily`)
};

const de_dropdailywhen2 = /** @type {(inputs: Dropdailywhen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täglich`)
};

/**
* | output |
* | --- |
* | "Daily" |
*
* @param {Dropdailywhen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailywhen2 = /** @type {((inputs?: Dropdailywhen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailywhen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailywhen2(inputs)
	return de_dropdailywhen2(inputs)
});
export { dropdailywhen2 as "dropDailyWhen" }